var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgService03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 79.5974,
    height: 79.5974,
    rx: 39.7987,
    fill: "#2A2A2A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.4317 54.7231V51.4066C46.4317 49.6473 45.7329 47.9602 44.4889 46.7162C43.245 45.4723 41.5578 44.7734 39.7986 44.7734H29.8489C28.0897 44.7734 26.4026 45.4723 25.1586 46.7162C23.9147 47.9602 23.2158 49.6473 23.2158 51.4066V54.7231",
    stroke: "white",
    strokeWidth: 3.31656,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8238 38.1405C38.4872 38.1405 41.4569 35.1708 41.4569 31.5074C41.4569 27.844 38.4872 24.8743 34.8238 24.8743C31.1604 24.8743 28.1907 27.844 28.1907 31.5074C28.1907 35.1708 31.1604 38.1405 34.8238 38.1405Z",
    stroke: "white",
    strokeWidth: 3.31656,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.3816 54.7231V51.4066C56.3805 49.9369 55.8913 48.5092 54.9909 47.3476C54.0905 46.1861 52.8298 45.3564 51.4067 44.989",
    stroke: "white",
    strokeWidth: 3.31656,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4319 25.0898C47.8587 25.4552 49.1233 26.285 50.0264 27.4484C50.9295 28.6119 51.4197 30.0428 51.4197 31.5157C51.4197 32.9885 50.9295 34.4195 50.0264 35.5829C49.1233 36.7464 47.8587 37.5762 46.4319 37.9415",
    stroke: "white",
    strokeWidth: 3.31656,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgService03);
export default __webpack_public_path__ + "static/media/service03.b7f7370d61edfab986f4213f41b53d8c.svg";
export { ForwardRef as ReactComponent };